module.exports = __webpack_public_path__ + "static/media/pool.d851978f.svg";